<template>
  <button
    type="button"
    role="switch"
    class="base-switch"
    :class="{
      'base-switch--on': value,
      'base-switch--disabled': disabled,
    }"
    :aria-checked="value ? 'true' : 'false'"
    :aria-label="ariaLabel"
    :disabled="disabled"
    :data-testid="dataTestid"
    @click="onToggle"
  >
    <span class="base-switch__track" aria-hidden="true">
      <span class="base-switch__thumb" />
    </span>
  </button>
</template>

<script>
export default {
  name: 'BaseSwitch',
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    ariaLabel: { type: String, default: 'Toggle' },
    dataTestid: { type: String, default: 'base-switch' },
  },
  methods: {
    onToggle() {
      if (this.disabled) return;
      this.$emit('input', !this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './BaseSwitch.scss';
</style>
